import PropTypes from 'prop-types';
import React from "react";

class customPending extends React.Component {

  render() {
    return <span className='loader simple-circle'></span>;
  }
}

customPending.propTypes = {
  bootstrapCss: PropTypes.bool
};

export default customPending;
